<assessment-result subTitle="UNKNOWN_TITLE_STILL_UNKNOWN"
                   subDesc="UNKNOWN_DESCRIPTION_STILL_UNKNOWN"
                   imageName="no_clue.svg">
</assessment-result>
<section class="layout-content mt">
  <button type="button" class="btn btn-secondary btn-lg btn-wide" (click)="onWorkshopSearch()">{{'WORKSHOP_SEARCH' | translate}}</button>
</section>
<assessment-text-link class="layout-content mt"></assessment-text-link>
